import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/blog/client.ts
var fetchClient2 = (_0) => __async(null, [_0], function* ({ url, options, raw }) {
  var _a;
  const blogConfig = (_a = ApiConfig.config) == null ? void 0 : _a.blog;
  if (!blogConfig) {
    const msg = "Blog `ApiConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
    throw new Error(msg);
  }
  return fetchClient({
    baseUrl: blogConfig.api,
    url,
    raw,
    options,
    includeAuth: false,
    includeToken: false
  });
});

export {
  fetchClient2 as fetchClient
};
//# sourceMappingURL=chunk-CPVMFYFD.mjs.map